import React, { useEffect, useState } from 'react';
import '../css/login.css'
import { bmsLogo as loginBmsLogo } from '../components/Images';import QRCodeCanvas from 'qrcode.react';
import { AssociateSoftwareTokenCommand, CognitoIdentityProviderClient, InitiateAuthCommand, RespondToAuthChallengeCommand, VerifySoftwareTokenCommand } from '@aws-sdk/client-cognito-identity-provider';
import { useNavigate } from 'react-router-dom';

const Login = () => {

    //const [user, setUser] = useState('');

    const [showLoginForm, setShowLoginForm] = useState(true);
    const [showChangePasswordForm, setShowChangePasswordForm] = useState(false);
    const [showVerifyUserForm, setShowVerifyUserForm] = useState(false);
    const [session, setSession] = useState(null);
    const [authParameters, setAuthParameters] = useState(null);
    const [usernameState, setUsernameState] = useState(null);
    const [showQRCode, setShowQRCode] = useState(null);
    const navigate = useNavigate();

    const handleAuthResponse = (response, username) =>{
        if(response.ChallengeName === "NEW_PASSWORD_REQUIRED"){
            setShowLoginForm(false);
            setShowChangePasswordForm(true);
            setAuthParameters(response.ChallengeParameters);
            setSession(response.Session);
            setUsernameState(username);
        }else if(response.ChallengeName === "MFA_SETUP"){
            setShowLoginForm(false);
            setShowChangePasswordForm(false);
            setShowVerifyUserForm(true);
            setAuthParameters(response.ChallengeParameters);
            setSession(response.Session);
            setShowQRCode(true);
            setUsernameState(username);
        }else if(response.ChallengeName === "SOFTWARE_TOKEN_MFA"){
            setShowLoginForm(false);
            setShowChangePasswordForm(false);
            setShowVerifyUserForm(true);  
            setSession(response.Session);
            setShowQRCode(false);
            setUsernameState(username);
        }else{
            navigate("/home", {replace: true});
        }
    }

    return (
        <div className='login-content'>
            <div className='login-form-content'>
                <div className="login-form">
                    <div className="login-logo-container">
                        <img src={loginBmsLogo} alt="" className="login-logo" />
                    </div>
                    {showLoginForm && <LoginForm onAuthResponse={handleAuthResponse}/>}
                    {showChangePasswordForm && <ChangePasswordForm session={session} authParameters={authParameters} onPasswordChange={handleAuthResponse} />}
                    {showVerifyUserForm && <VerifyUserForm  userInfo={{session:session, username: usernameState}} onTotpSubmit={handleAuthResponse} showQRCode={showQRCode}/>}
                </div>
            </div>
        </div>
    );
}

const LoginForm = ({onAuthResponse}) => {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [usernameError, setUsernameError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [loginError, setLoginError] = useState('');

    const validateEmptiness = () => {
        setUsernameError(username === "" ? true : false);
        setPasswordError(password === "" ? true : false);
    };

    const handleLoginError = (message) => {
        if (message === 'Incorrect username or password.'){
            setLoginError('Usuario o contraseña incorrectos');
        }
    }

    const handleSubmit = async(event) => {
        event.preventDefault();
        validateEmptiness();

        try {
            const client = new CognitoIdentityProviderClient({region: process.env.REACT_APP_COGNITO_AWS_REGION});
            const input = { 
                "AuthFlow": "USER_PASSWORD_AUTH",
                "ClientId": process.env.REACT_APP_COGNITO_CLIENT_ID,
                "AuthParameters": {
                    "USERNAME": username,
                    "PASSWORD": password
                }
            }
            const command = new InitiateAuthCommand(input);
            const response = await client.send(command);
            onAuthResponse(response, username);
            
        } catch (NotAuthorizedException) {
            console.error(NotAuthorizedException);
            handleLoginError(NotAuthorizedException.message);
        }

    }

    return (
      <>
        <h1>Iniciar Sesión</h1>
        <form onSubmit={handleSubmit}>
          <div className="login-container-input">
            <label htmlFor="username" className="input-login-lbl">
              Usuario
            </label>
            <input
              type="text"
              id="username"
              className={usernameError ? 'input-login input-validation-error' : 'input-login'}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="on"
            />
            <span className={usernameError ? "field-validation-error" : "hidden"}>
              El campo Usuario es requerido.
            </span>
          </div>
          <div className="login-container-input">
            <label htmlFor="password" className="input-login-lbl">
              Contraseña
            </label>
            <input
              type="password"
              id="password"
              className={passwordError ? 'input-login input-validation-error' : 'input-login'}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="on"
            />
            <span className={usernameError ? "field-validation-error" : "hidden"}>
              El campo Contraseña es requerido.
            </span>
          </div>
          <div className="login-container-btn">
            <span className={loginError !== '' ? 'field-validation-error' : 'hidden'}>
                {loginError}
            </span>
            <input
              type="submit"
              value="Iniciar Sesión"
              className="login-submit-btn"
            />
          </div>
        </form>
      </>
    );
}

const ChangePasswordForm = ({session, authParameters, onPasswordChange}) => {
    const [newPassword, setNewPassword] = useState(null);
    const [newPasswordConfirm, setNewPasswordConfirm] = useState(null);
    const [newPasswordError, setNewPasswordError] = useState(null);
    const [newPasswordConfirmError, setNewPasswordConfirmError] = useState(null);
    const [changePasswordError, setChangePasswordError] = useState(null);

    const validateEmptiness = () => {
        setNewPasswordError(newPassword === "" || newPassword === null ? 'El campo Nueva Contraseña es requerido.' : null);
        setNewPasswordConfirmError(newPasswordConfirm === "" || newPasswordConfirm === null ? 'El campo Confirmar Contraseña es requerido.' : null);
    };

    const verifyEquality = () => {
        if ( newPassword !== newPasswordConfirm ){
            setChangePasswordError('Las contrasñas no coinciden.');
            setNewPasswordError(true)
            setNewPasswordConfirmError(true)
            return false;
        }else{
            setChangePasswordError(false);
            return true;
        }
    }

    const handleChangePasswordError = (message) => {
        const possibleErrors = {
            specialCharacters : 'Password does not conform to policy: Password must have symbol characters',
            numericCharacters : 'Password does not conform to policy: Password must have numeric characters',
            passLength : 'Password does not conform to policy: Password not long enough',
            uppercaseCharacters : 'Password does not conform to policy: Password must have uppercase characters',
            lowercaseCharacters : 'Password does not conform to policy: Password must have lowercase characters',
        }
        const errorsTranslation = {
            specialCharacters : 'La contraseña debe contener caracteres especiales.',
            numericCharacters : 'La contraseña debe contener caracteres numéricos.',
            passLength : 'La contraseña debe tener más de 8 caracteres.',
            uppercaseCharacters : 'La contraseña debe contener letras mayúsculas.',
            lowercaseCharacters : 'La contraseña debe contener letras minúsculas.',
        }
        let errorsTranslationKey = null;
        for (const key in possibleErrors) {
            if (possibleErrors[key] === message) {
                errorsTranslationKey = key;
            }
        }
        errorsTranslationKey ? setChangePasswordError(errorsTranslation[errorsTranslationKey]): setChangePasswordError(message) ;
    }

    const handleSubmit = async(event) => {
        event.preventDefault();
        validateEmptiness();
        const equalPasswords = verifyEquality();
        try{
            if (equalPasswords){
                const client = new CognitoIdentityProviderClient({region: process.env.REACT_APP_COGNITO_AWS_REGION});
                const input = { 
                    "ClientId": process.env.REACT_APP_COGNITO_CLIENT_ID, 
                    "ChallengeName": "NEW_PASSWORD_REQUIRED", 
                    "Session": session,
                    "ChallengeResponses": { // ChallengeResponsesType
                        "USERNAME": authParameters.USER_ID_FOR_SRP,
                        "NEW_PASSWORD": newPassword
                    }
                };
                const command = new RespondToAuthChallengeCommand(input);
                const response = await client.send(command);
                onPasswordChange(response, authParameters.USER_ID_FOR_SRP);
            }
        }catch(e){
            handleChangePasswordError(e.message);
            console.error(e);
        }
    }

    return (        
        <>
            <h1>Cambiar contraseña</h1>
            <form onSubmit={handleSubmit}>
                <div className='login-container-input'>
                    <label htmlFor="passwd" className='input-login-lbl'>Nueva contraseña</label>
                    <input 
                        type="password" 
                        id='passwd'
                        className={newPasswordError || changePasswordError ? 'input-login input-validation-error' : 'input-login'}
                        onChange={(e) => setNewPassword(e.target.value)}
                        autoComplete='on'
                        />
                    <span className={newPasswordError ? 'field-validation-error' : 'hidden'}>{newPasswordError}</span>
                </div>
                <div className='login-container-input'>
                    <label htmlFor="confirmPasswd" className='input-login-lbl'>Confirmar contraseña</label>
                    <input 
                        type="password" 
                        id='confirmPasswd'
                        className={newPasswordConfirmError || changePasswordError ? 'input-login input-validation-error' : 'input-login'}
                        onChange={(e) => setNewPasswordConfirm(e.target.value)} 
                        autoComplete='on'
                    />
                    <span className={newPasswordConfirmError ? 'field-validation-error' : 'hidden'}>{newPasswordConfirmError}</span>
                </div>
                <div className='login-container-btn'>
                    <span className={changePasswordError ? 'field-validation-error' : 'hidden'}>{changePasswordError}</span>
                    <input type="submit" value="Iniciar Sesión" className='login-submit-btn'/>
                </div>
            </form>
        </>
    );
}

const VerifyUserForm = ({userInfo, showQRCode, onTotpSubmit}) => {

    const [totpCode, setTotpCode] = useState(null);
    const [assocSTSession, setAssocSTSession] = useState(userInfo.session);
    const [qrStr, setQrStr] = useState(null);
    const [totpCodeError, setToptCodeError] = useState(null);

    const associateSoftwareToken = async()=>{
        const client = new CognitoIdentityProviderClient({region: process.env.REACT_APP_COGNITO_AWS_REGION});
        const input = { // AssociateSoftwareTokenRequest
            Session: assocSTSession,
        };
        const command = new AssociateSoftwareTokenCommand(input);
        const response = await client.send(command);
        setAssocSTSession(response.Session)
        setQrStr("otpauth://totp/AWSCognito:"+ userInfo.username + "?secret=" + response.SecretCode + "&issuer=iqviatech");
    }
    
    useEffect(() => {
        if (showQRCode) {
            associateSoftwareToken();
        }
    },[])
    
    const handleMfaSubmit = (event) => {
        event.preventDefault();
        showQRCode && verifySoftwareToken();
        !showQRCode && insertSoftwareTokenMfa();
    }

    const insertSoftwareTokenMfa = async() => {
        try{
            if(verifyUserCodeLength()){
                const client = new CognitoIdentityProviderClient({region: process.env.REACT_APP_COGNITO_AWS_REGION});
                const input = { // RespondToAuthChallengeRequest
                    "ClientId": process.env.REACT_APP_COGNITO_CLIENT_ID, 
                    "ChallengeName": "SOFTWARE_TOKEN_MFA", 
                    "Session": assocSTSession,
                    "ChallengeResponses": { // ChallengeResponsesType
                        "USERNAME": userInfo.username,
                        "SOFTWARE_TOKEN_MFA_CODE": totpCode
                    }
                };
                const command = new RespondToAuthChallengeCommand(input);
                const response = await client.send(command);
                onTotpSubmit(response,userInfo.username);
            }
        }catch(e){
            setToptCodeError("Código incorrecto.")
        }
    }
    
    const verifySoftwareToken = async() => {
        try {
            if(verifyUserCodeLength()){
                const client = new CognitoIdentityProviderClient({region: process.env.REACT_APP_COGNITO_AWS_REGION});
                const input = { 
                    Session: assocSTSession,
                    UserCode: totpCode, 
                    FriendlyDeviceName: "IqviaTest",
                };
                const command = new VerifySoftwareTokenCommand(input);
                const response = await client.send(command);
                setAssocSTSession(response.Session);
                onTotpSubmit(response, userInfo.username )
            }
        }catch(e){
            setToptCodeError("Código incorrecto.")
        }
    }

    const verifyUserCodeLength = () => {
        if (totpCode !== null){
            if (totpCode.length === 0){
                setToptCodeError("El campo Código de verificación es requerido.")
                return false;
            }else if (totpCode.length === 6 ){
                setToptCodeError(null)
                return true;
            }else{
                setToptCodeError("Código incorrecto.")
                return false;
            }
        }else{
            setToptCodeError("El campo Código de verificación es requerido.")
            return false;
        }
    }

    return (        
        <>
            <h1>Verificación de Seguridad</h1>
            <form onSubmit={handleMfaSubmit}>
                {showQRCode && qrStr && 
                    <div className='login-container-input'>
                        <span className='input-login-lbl'>Escanea el código QR:</span><br />
                        <div className='login-qr-container'>
                            <QRCodeCanvas 
                            size={200}
                            value={qrStr}
                             />
                        </div>
                    </div>
                }
                <div className='login-container-input'>
                    <label htmlFor="verificationCode" className='input-login-lbl'>Código de verificación</label>
                    <input 
                        type="number" 
                        id='verificationCode'
                        className={ totpCodeError ? 'input-login input-validation-error' : 'input-login'}
                        onChange={(e) => setTotpCode(e.target.value)} 
                    />
                    <span className={totpCodeError ? 'field-validation-error' : 'hidden'}>{totpCodeError}</span>
                </div>
                <div className='login-container-btn'>
                    <input type="submit" value="Continuar" className='login-submit-btn'/>
                </div>
            </form>
        </>      
    );
}

export default Login;
